import React, { useState } from "react";
import logo from "../assets/images/olympusLogo.png";
import { NewPasswordForm } from "../components/NewPasswordForm";
import { SignInForm } from "../components/SignInForm";

export default function SignInView() {
  const [needsNewPassword, setNeedsNewPassword] = useState(false);

  return (
    <div className="sign-in mw-100 m-auto mt-3 d-flex flex-column align-items-center">
      <img className="mw-100 object-fit-contain" src={logo} alt="Logo" />
      {needsNewPassword
        ? (
          <>
            <h1 className="mt-3">Set your password</h1>
            <NewPasswordForm />
          </>
        )
        : (
          <>
            <h1 className="mt-3">Sign in to Olympus</h1>
            <SignInForm setNeedsNewPassword={setNeedsNewPassword} />
          </>
        )}
    </div>
  );
}
